import { PageHeader } from '@celltrak/ui-components';

const RequiredFieldsHeader = () => (
  <header>
    <PageHeader title="Required Fields" />
  </header>
);

export default RequiredFieldsHeader;
